import { isFailureReason, type FailureInfo } from '@1qa/shared';
import type { TestResult } from './types';

/** A result's stored failure reason (TestResult.failure), when it failed and the reason is one this app knows. */
export const failureOf = (r: Pick<TestResult, 'status' | 'failure'>): FailureInfo | null =>
  (r.status === 'FAILED' || r.status === 'ERROR') && r.failure && isFailureReason(r.failure.reason) ? r.failure : null;
